import React from 'react';
import { CheckCircle, LockKeyhole } from 'lucide-react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../ui/alert-dialog.js';
import { formatCurrency } from '../../utils/formatters.js';

const VehicleVisitLifecycleConfirmDialog = ({
    open,
    onOpenChange,
    action,
    expectedTotal = 0,
    isLoading = false,
    onConfirm,
}) => {
    const isFinalization = action === 'finalize';
    const title = isFinalization ? 'اعتماد إجمالي الزيارة' : 'إغلاق الزيارة';
    const description = isFinalization
        ? `ستُعتمد ذمة العميل بمبلغ ${formatCurrency(expectedTotal)}. بعد الاعتماد لا يمكن تعديل البنود.`
        : 'سيتم إغلاق الزيارة تشغيليًا. لا ينشئ هذا الإجراء قيدًا ماليًا جديدًا.';
    const confirmLabel = isFinalization ? 'اعتماد الإجمالي النهائي' : 'إغلاق الزيارة';

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent dir="rtl" className="border-0 p-0 bg-transparent" data-testid={`visit-${action}-confirm-dialog`}>
                <div
                    className="rounded-[28px] overflow-hidden"
                    style={{
                        background: 'radial-gradient(circle at 12% 18%, rgba(79,70,229,0.24), transparent 52%), radial-gradient(circle at 88% 78%, rgba(59,130,246,0.14), transparent 55%), rgba(15,23,42,0.98)',
                        border: '1px solid rgba(129,140,248,0.34)',
                        boxShadow: '0 40px 140px rgba(2,6,23,0.9)',
                    }}
                >
                    <AlertDialogHeader className="px-6 pt-6 text-right">
                        <div className="flex items-start gap-3">
                            <div className="w-12 h-12 rounded-2xl bg-indigo-400/15 border border-indigo-300/25 flex items-center justify-center shrink-0">
                                {isFinalization ? <LockKeyhole className="text-indigo-100" size={22} /> : <CheckCircle className="text-emerald-100" size={22} />}
                            </div>
                            <div>
                                <AlertDialogTitle className="text-slate-50 text-lg font-bold">{title}</AlertDialogTitle>
                                <AlertDialogDescription className="text-slate-200/80 text-sm mt-2 leading-6">
                                    {description}
                                </AlertDialogDescription>
                            </div>
                        </div>
                    </AlertDialogHeader>
                    <AlertDialogFooter className="px-6 pb-6 pt-5 gap-2 sm:gap-3 sm:justify-end">
                        <AlertDialogCancel className="apple-button-secondary" disabled={isLoading} data-testid={`visit-${action}-confirm-cancel`}>
                            إلغاء
                        </AlertDialogCancel>
                        <AlertDialogAction
                            className="h-11 px-4 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-bold disabled:opacity-50"
                            data-testid={`visit-${action}-confirm-submit`}
                            disabled={isLoading}
                            onClick={(event) => {
                                event.preventDefault();
                                onConfirm?.();
                            }}
                        >
                            {isLoading ? 'جارٍ التنفيذ...' : confirmLabel}
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </div>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default VehicleVisitLifecycleConfirmDialog;
